import { graphql } from "relay-runtime"

export const ch_PointOfCareSpecialtyQuery = graphql`
  query useChPointOfCareSpecialtyQuery($searchText: String!) {
    chPointOfCareSpecialties: ch_pointOfCareSpecialties(
      first: 50
      order: [{ word: ASC }]
      where: {
        or: [
          { word: { contains: $searchText } }
          { synonym: { contains: $searchText } }
          { specialtyTranslations: { some: { name: { contains: $searchText } } } }
        ]
      }
    ) {
      nodes {
        id
        word
        synonym
        specialtyTranslations {
          language
          name
        }
        careProviderSpecialty {
          id
          name
        }
      }
    }
  }
`
